import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import './AvatarBorderPreviewBanner.css';

interface AvatarBorderPreviewBannerProps {
  userId: string | number | undefined;
  visible: boolean;
}

const storageKey = (userId: string | number | undefined) =>
  `avatarBorderPreview.dismissed.${userId ?? 'anon'}`;

export default function AvatarBorderPreviewBanner({
  userId,
  visible,
}: AvatarBorderPreviewBannerProps) {
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(storageKey(userId)) === 'true';
  });

  useEffect(() => {
    setDismissed(localStorage.getItem(storageKey(userId)) === 'true');
  }, [userId]);

  if (!visible || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(storageKey(userId), 'true');
    setDismissed(true);
  };

  return (
    <div className="avatar-border-preview-banner">
      <div className="avatar-border-preview-banner-content">
        <svg
          className="avatar-border-preview-banner-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2l2.39 4.84L20 7.76l-3.75 3.65.89 5.17L12 14.21l-5.14 2.37.89-5.17L4 7.76l5.61-.92L12 2z"
            fill="currentColor"
          />
        </svg>
        <span className="avatar-border-preview-banner-text">
          Your border is ready.{' '}
          <Link
            to="/elite?source=avatar-border-preview"
            className="avatar-border-preview-banner-link"
          >
            Subscribe to Elite
          </Link>{' '}
          to make it live.
        </span>
      </div>
      <button
        className="avatar-border-preview-banner-dismiss"
        onClick={handleDismiss}
        type="button"
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
}
